import React, { useState, useRef, useEffect } from "react";
import { InputWithButton } from "./InputWithButton";
import { useMouseupListener } from "../../hooks/listeners/useMouseupListener";
import { isFunction } from "lodash";
import { noop } from "lodash/fp";
import { Tooltip } from "./Tooltip/Tooltip";

export const ItemWithInput = ({
  children,
  inputProps,
  tooltipProps,
  opened: openedProp,
  className,
  tooltipBoxClassName,
  onClick,
  disabled,
}) => {
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState("");
  const containerRef = useRef();
  const controlled = openedProp !== undefined;
  useMouseupListener(
    (e) => {
      if (
        opened &&
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setOpened(false);
      }
    },
    [opened]
  );
  useEffect(() => {
    if (controlled) {
      setOpened(openedProp);
    }
  }, [controlled, openedProp]);

  return (
    <div
      ref={containerRef}
      className={className}
      onClick={disabled ? noop : onClick || (() => setOpened((v) => !v))}
    >
      {isFunction(children) ? children({ opened, setOpened }) : children}
      <Tooltip
        listenToAllParentScrolls
        showing={opened}
        position={"bottom-start"}
        boxClassName={tooltipBoxClassName}
        interactive
        {...tooltipProps}
      >
        <InputWithButton
          autoFocus
          preventAutoFocusScroll
          value={value}
          onChange={(e) => setValue(e.target.value)}
          {...inputProps}
          onSubmit={() => {
            if (inputProps.onSubmit) {
              inputProps.onSubmit(inputProps.value || value);
              setValue("");
              setOpened(false);
            }
          }}
        />
      </Tooltip>
    </div>
  );
};
